<div tid="note_detail" class="container" [ngClass]="{'maximum': isShowMaximun}" tabindex="-1" (keyup)="onKeyup($event)">
    <div class="no-data-box" *ngIf="isNoData">
        <span>Select an item to view</span>
    </div>
    <div class="has-data-box" *ngIf="!isNoData">
        <div class="tool-bar" kendoTooltip position="bottom" tooltipClass="tooltip-adjust-right">
            <smart-icon title="Delete" name="trash" class="light" tid="delete_note" (click)="delete()"></smart-icon>
            <smart-icon title="Exit Full View" name="window-minimize" class="light" (click)="onMaximumClick()"
                *ngIf="!config.singlePageMode && isShowMaximun ? true : false" tid="minimize_note"></smart-icon>
            <smart-icon title="Full View" name="window-maximize" class="light" (click)="onMaximumClick()"
                *ngIf="config.singlePageMode || isShowMaximun ? false : true" tid="maximize_note"></smart-icon>
            <smart-icon title="Deposit selected item" name="add-note" class="light" tid="deposit_as_note"
                (click)="clickDepositNote()"></smart-icon>
            <smart-icon title="Fast Deposit selected item" *ngIf="canDepositFast" name="quickcreate-note"
                (click)="clickFastDepositNote()" class="light" tid="deposit_as_note_fast"></smart-icon>
            <smart-icon title="Create Contact" *ngIf="!blastEmail.contact" name="add-contact" class="light"
                (click)="onAddContactClick()" tid="new_contact"></smart-icon>
            <smart-icon title="Fast Create Contact" *ngIf="canAddContactFast&&blastEmail.fromPersonName"
                name="quickcreate-contact" class="light" (click)="clickFastAddContact()" tid="new_contact_fast">
            </smart-icon>
        </div>
        <div #contentBox class="content-box">
            <div tid="note_detail_entity" class="entities-box" kendoTooltip position="bottom"
                tooltipClass="tooltip-adjust-right">
                <a class="entity-tag" [ngClass]="{'highlight': isEntityTagHighlight(item.shortName)}"
                    *ngFor="let item of blastEmail.entities; trackBy:trackByFn" [title]="item.shortName"
                    (click)="onClickTag(item,$event)" [href]="getEntityTagHref(item)">
                    <span>{{item.shortName}}</span>
                </a>
            </div>
            <div class="attachment-box" *ngIf="blastEmail.attachments  && blastEmail.attachments.size > 0">
                <attachment-list [attachments]="attachmentViewModelList" [canShare]="false"></attachment-list>
            </div>
            <div class="blastemail-data-container" *ngIf="renderHighlight">
                <blastemail-detail-header [blastEmail]="blastEmail" [highlightText]="keywords" (toggle)="onToggle()">
                </blastemail-detail-header>
                <note-detail-body [body]="blastEmail.body" [highlightText]="keywords"
                    [style.display]="showBlastEmailBody ? '' : 'none'"></note-detail-body>
            </div>
        </div>
    </div>
</div>